<template>
  <div v-loading="loading" class="rj-page-card">
    <div class="rj-page-card__title">
      订单全流程
    </div>
    <!-- 订单时间线 -->
    <div class="timelineBox">
      <div class="timeItem">
        <div class="timeline-title">
          预计达成：
        </div>
        <div class="timeline-content">
          <OderTimeLine :data-list="this.expectedAchieveList" />
        </div>
      </div>
      <div class="timeItem">
        <div class="timeline-title">
          实际达成：
        </div>
        <div class="timeline-content">
          <OderTimeLine :data-list="this.actualAchieveList" />
        </div>
      </div>
      <div class="timeItem">
        <div class="timeline-title">
          付款状态<br>
          （{{ info?.strSalesType }}）：
        </div>
        <div class="timeline-content">
          <OderTimeLine :data-list="this.paymentList" />
        </div>
      </div>
      <div class="timeItem">
        <div class="timeline-title">
          开票状态：
        </div>
        <div class="timeline-content">
          <OderTimeLine :data-list="this.InvoiceList" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import OderTimeLine from '@/components/orderTimeLine';
import { getExpectedAndActualAchieveProcess, getPaymentStatusProcess, getInvoicetStatusProcess } from '@/API';
export default {
  props: {
    contractNum: {
      type: [String, Number],
      required: true
    },
    info: {
      type: Object,
      required: true,
      default: () => { return { }; }
      // 现销或赊销 如果为现销 ，则需要付款时间线 设置tip 日期 strSalesType: ''
    }
  },
  data () {
    return {
      loading: false,
      expectedAchieveList: [], // 预计达成时间线
      actualAchieveList: [], // 实际达成时间线
      paymentList: [], // 付款时间线
      InvoiceList: [] // 开票时间线

    };
  },
  components: {
    OderTimeLine // 组件内数据格式 { title: '创建时间', time: '2025-04-20', line: '', staus: '1', tip: '2025-05-01' },
  },
  watch: {
    info: {
      handler (newVal, oldVal) {
        if (newVal.strSalesType) {
          this.init(this.contractNum, newVal.strSalesType);
          // this.init('100224081500303', newVal.strSalesType);
          // this.init('100023071900302', newVal.strSalesType);
          // this.init('101025031000330', newVal.strSalesType);
        }
      },
      immediate: true
    }
  },
  methods: {
    init (contractNum, strSalesType) {
      getExpectedAndActualAchieveProcess({ contractNum }).then(response => {
        const res = response?.data;
        if (response.status === 200) {
          const expected = res?.data?.expectedAchieveList || [];
          const actual = res?.data?.actualAchieveList || [];
          if (expected.length === 0) {
            this.expectedAchieveList = [];
          } else {
          // 预计达成
            this.expectedAchieveList = [
              { title: expected[0].expectedOrderCreateTimeName, time: expected[0].expectedOrderCreateTime, line: '', staus: expected[0].expectedOrderCreateTimeStatus, tip: '' },
              { title: expected[1].expectedOrderTimeName, time: expected[1].expectedOrderTime, line: '', staus: expected[1].expectedOrderTimeStatus, tip: '' },
              { title: expected[2].expectedStockPreparationStartName, time: expected[2].expectedStockPreparationStartTime, line: expected[2].expectedStockPreparationSlaDays, staus: expected[2].expectedStockPreparationStatus, tip: '' },
              { title: expected[3].expectedStockPreparationEndName, time: expected[3].expectedStockPreparationEndTime, line: expected[3].expectedStockPreparationEndSlaDays, staus: expected[3].expectedStockPreparationEndStatus, tip: '' },
              { title: expected[4].expectedOrderDeliveryName, time: expected[4].expectedOrderDeliveryTime, line: expected[4].expectedOrderDeliverySlaDays, staus: expected[4].expectedOrderDeliveryStatus, tip: '' },
              { title: expected[5].expectedDeliveryConfirmationName, time: expected[5].expectedDeliveryConfirmationTime, line: expected[5].expectedDeliveryConfirmationSlaDays, staus: expected[5].expectedDeliveryConfirmationStatus, tip: '' }
            ];
          }
          if (actual.length === 0) {
            this.actualAchieveList = [];
          } else {
            // 实际达成
            this.actualAchieveList = [
              { title: actual[0].actualOrderCreateTimeName, time: actual[0].actualOrderCreateTime, line: '', staus: actual[0].actualOrderCreateTimeStatus, tip: '' },
              { title: actual[1].actualOrderTimeName, time: actual[1].actualOrderTime, line: '', staus: actual[1].actualOrderTimeStatus, tip: '' },
              { title: actual[2].actualStockPreparationStartName, time: actual[2].actualStockPreparationStartTime, line: '', staus: actual[2].actualStockPreparationStartTimeStatus, tip: '' },
              { title: actual[3].actualStockPreparationEndName, time: actual[3].actualStockPreparationEndTime, line: '', staus: actual[3].actualStockPreparationEndStatus, tip: '' },
              { title: actual[4].actualOrderDeliveryName, time: actual[4].actualOrderDeliveryTime, line: '', staus: actual[4].actualOrderDeliveryStatus, tip: '' },
              { title: actual[5].actualDeliveryConfirmationName, time: actual[5].actualDeliveryConfirmationTime, line: '', staus: actual[5].actualDeliveryConfirmationStatus, tip: '' }
            ];
          }
        }
      }).catch(err => {
        console.log('error', err);
      });
      let paymentType = strSalesType === '现销' ? '1' : '0';
      getPaymentStatusProcess({ contractNum, paymentType }).then(response => {
        const res = response?.data;
        if (response.status === 200) {
          const firstPaymentList = res?.data?.firstPaymentList || [];
          const lastPaymentList = res?.data?.lastPaymentList || [];
          if (firstPaymentList.length !== 0 && lastPaymentList.length !== 0) {
            // 付款时间
            this.paymentList = [
              { title: firstPaymentList[0].firstPaymentName, time: firstPaymentList[0].firstPaymentTime, line: '', staus: firstPaymentList[0].firstPaymentStatus, tip: this.info.strSalesType === '现销' ? res?.data?.completionTime : '' },
              { title: lastPaymentList[0].lastPaymentName, time: lastPaymentList[0].lastPaymentTime, line: '', staus: lastPaymentList[0].lastPaymentStatus, tip: '' }
            ];
          } else {
            // 付款时间
            this.paymentList = [];
          }
        }
      }).catch(err => {
        console.log('error', err);
      });
      getInvoicetStatusProcess({ contractNum }).then(response => {
        const res = response?.data;
        if (response.status === 200) {
          const firstInvoiceList = res?.data?.firstInvoiceList || [];
          const lastInvoiceList = res?.data?.lastInvoiceList || [];
          if (firstInvoiceList.length !== 0 && lastInvoiceList.length !== 0) {
            // 开票时间
            this.InvoiceList = [
              { title: firstInvoiceList[0].firstInvoiceName, time: firstInvoiceList[0].firstInvoiceTime, line: '', staus: firstInvoiceList[0].firstInvoiceStatus, tip: '' },
              { title: lastInvoiceList[0].lastInvoiceName, time: lastInvoiceList[0].lastInvoiceTime, line: '', staus: lastInvoiceList[0].lastInvoiceStatus, tip: '' }
            ];
          } else {
            this.InvoiceList = [];
          }
        }
      }).catch(err => {
        console.log('error', err);
      });
    }
  }
};
</script>
<style lang="scss" scope>
.timelineBox {
  width: 100%;
  height: 100%;
  padding: 20px 15px 0;
  background: #fff;
  font-family: 'Microsoft YaHei';

  .timeItem {
    width: 100%;
    height: 100%;

    .timeline-title {
      display: inline-block;
      width: 100px;
      height: 60px;
      padding-top: 18px;
      vertical-align: top;
      font-size: 15px;
      font-weight: bold;
      color: rgba(80, 80, 80, 1);
    }

    .timeline-content{
      display: inline-block;
      width: calc(100% - 100px);
      height: 100%;
      margin-bottom: 30px;
      min-height: 102px;
      overflow-x: auto;
      overflow-y: hidden;
    }

  }
}
</style>
